import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';

interface RequireAuthProps {
  children: React.ReactNode;
}

export default function RequireAuth({ children }: RequireAuthProps): JSX.Element {
  const { user, authLoading } = useAuth();
  const location = useLocation();
  // While the real Firebase SDK is restoring a persisted session, hold the
  // route instead of redirecting — otherwise a refresh of an authenticated
  // page bounces the user to /login before restoration finishes (comment #8).
  if (authLoading) {
    return (
      <div role="status" aria-busy="true" aria-live="polite">
        Restoring your session…
      </div>
    );
  }
  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }
  return <>{children}</>;
}
